export default class WebStorageStub {
  constructor(type) {
    this.type = type;
    this.keys = [];
    this.length = 0;
  }

  getItem(key) {
    const data = this[key];
    let result;

    if (data) {
      result = data.value;
    } else {
      result = null;
    }

    return result;
  }

  setItem(key, value) {
    if (this.keys.indexOf(key) === -1) {
      this.keys.push(key);
      this.length = this.keys.length;
    }

    this[key] = {
      value,
    };
  }

  removeItem(key) {
    const index = this.keys[key];

    if (index > -1) {
      this.keys.splice(index, 1);
      delete this[key];
      this.length = this.keys.length;
    }
  }

  clear() {
    this.keys.forEach((key) => {
      this.removeItem(key);
    });
  }
}
